import { apiRequest } from './apiService';

// Inventory Stock
export const fetchInventoryStock = async () => {
  return await apiRequest('/inventory/inventory-stock', 'GET');
};

export const fetchStockById = async (stockId: string) => {
  return await apiRequest(`/inventory/inventory-stock/${stockId}`, 'GET');
};

export const createInventoryStock = async (stockData: any) => {
  return await apiRequest('/inventory/inventory-stock', 'POST', stockData);
};

export const updateInventoryStock = async (stockId: any, stockData: any) => {
  return await apiRequest(
    `/inventory/inventory-stock/${stockId}`,
    'PUT',
    stockData
  );
};

export const deleteInventoryStock = async (stockId: string) => {
  return await apiRequest(`/inventory/inventory-stock/${stockId}`, 'DELETE');
};
export const fetchStockByProductId = async (productId: string) => {
  return await apiRequest(
    `/inventory/inventory-stock/product/${productId}`,
    'GET'
  );
};
export const fetchStockByLocationId = async (locationId: string) => {
  return await apiRequest(
    `/inventory/inventory-stock/location/${locationId}`,
    'GET'
  );
};
export const fetchStockByLocationAndProductId = async (
  locationId: string,
  productId: string
) => {
  return await apiRequest(
    `/inventory/inventory-stock/${locationId}/${productId}`,
    'GET'
  );
};
export const fetchStockByLocationAndProduct = async (
  locationId: string,
  productId: string
) => {
  return await apiRequest(
    `/inventory/inventory-stock/${locationId}/${productId}`,
    'GET'
  );
};
